import Main from '@/views/Main.vue'
import Portfolio from '@/views/client/Portfolio'
import PortfolioHistory from "@/views/client/PortfolioHistory";
// import ClientMain from '@/views/client/Main.vue'
// import Portfolio from '@/views/client/Portfolio.vue'
// import PortfolioChangeHistory from '@/views/client/PortfolioChangeHistory'
import SymbolInfo from '@/views/client/SymbolInfo'
// import {userPerimeter} from '@/perimeters'

const clientRoute = {
  path: '/client',
  redirect: '/client/portfolio',
  component: Main,
  children: [
  //   {
  //     key: 'memberInfo',
  //     path: 'info',
  //     component: ClientMain,
  //     meta: {
  //       perimeter: userPerimeter,
  //       perimeterAction: 'read'
  //     }
  //   },
    {
      key: 'portfolio',
      path:'portfolio',
      component: Portfolio
    },
    {
      key:'portfolio_history',
      path:'portfolio_history',
      component: PortfolioHistory
    },
    {
      key:'symbol_info',
      path:'symbols/:symbol',
      component: SymbolInfo,
    }
  ]
}

export default clientRoute
